// @flow
import React from 'react';
import classnames from 'classnames';

import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton.jsx';

type Props = {
  className?: string,
  isNextDisabled?: boolean,
  isPrevDisabled?: boolean,
  nextLabel?: string,
  onNext: () => void,
  onPrev: () => void,
  previousLabel?: string,
  style?: *,
};

export function ImmersiveSlideShowControls(props: Props) {
  const {
    className,
    style,
    isNextDisabled,
    isPrevDisabled,
    nextLabel,
    onNext,
    onPrev,
    previousLabel,
  } = props;

  return (
    <div
      className={classnames(
        className,
        'absolute flex items-center justify-between max-w-site m-auto inset-0 pointer-events-none w-full',
      )}
      style={style}
    >
      {!isPrevDisabled && (
        <ArrowButton
          className="rtl:ml-2 lg:rtl:ml-0 rtl:mr-auto pointer-events-auto shadow-sm z-1"
          label={previousLabel}
          onClick={onPrev}
        />
      )}
      {!isNextDisabled && (
        <ArrowButton
          className="rtl:mr-2 lg:rtl:mr-0 rtl:ml-auto pointer-events-auto shadow-sm z-1"
          label={nextLabel}
          onClick={onNext}
          rotation={180}
        />
      )}
    </div>
  );
}
